import React from 'react';
import { format, parseISO } from 'date-fns';
import MediaQuery from 'react-responsive';

import { MiniCalendar, MiniClock, SuccessTickIcon } from '@nw/shared/ui';

import { EXCLUSIVE_EBOOK_IMAGE_URL } from '../../constants/FormConstant';

import {
  CalendarTimeContainer,
  CalendarTimeRow,
  DateText,
  DescriptionText,
  DividerLine,
  EBookImage,
  IconWrapper,
  MainContainer,
  SuccessCardContainer,
  TitleText
} from './StyledComponent';

interface SuccessMessageContainerWithEmailMessageProps {
  title?: string;
  description?: string;
  slotDate?: string;
  slotTime?: string;
  email?: string;
  customClassNames?: {
    container?: string;
    card?: string;
    title?: string;
    description?: string;
    [key: string]: string | undefined;
  };
}

export const SuccessMessageContainerWithEmailMessage: React.FC<
  SuccessMessageContainerWithEmailMessageProps
> = ({ title, description, slotDate, slotTime, email, customClassNames }) => {
  //NOTE: This is a dummy email to bypass the validation, need to improve this logic
  const shouldShowEbookImage = Boolean(email && email !== 'dummy#@gmail.com');

  const formatDate = (
    dateString?: string,
    includeWeekday: boolean = false
  ): string => {
    if (!dateString) return '';

    try {
      const date = parseISO(dateString);
      if (isNaN(date.getTime())) {
        const fallbackDate = new Date(dateString);
        if (isNaN(fallbackDate.getTime())) {
          return dateString;
        }
        if (includeWeekday) {
          return format(fallbackDate, 'd MMMM yyyy, EEEE');
        }
        return format(fallbackDate, 'd MMMM yyyy');
      }

      if (includeWeekday) {
        return format(date, 'd MMMM yyyy, EEEE');
      }
      return format(date, 'd MMMM yyyy');
    } catch (error) {
      return dateString;
    }
  };

  const formatTime = (timeString?: string): string => {
    if (!timeString) return '';
    const parts = timeString.split(' - ');
    if (parts.length > 1) {
      return parts[parts.length - 1].trim();
    }
    return timeString.trim();
  };

  return (
    <MainContainer
      className={`${customClassNames?.container} custom-success-message-container-class`}
    >
      <SuccessCardContainer className={customClassNames?.card}>
        <IconWrapper>
          <SuccessTickIcon height={38} width={38} />
        </IconWrapper>

        <TitleText
          className={customClassNames?.title}
          dangerouslySetInnerHTML={{
            __html: title || 'Thankyou for your Interest'
          }}
        />

        <DescriptionText
          className={customClassNames?.description}
          dangerouslySetInnerHTML={{
            __html:
              description ||
              "Your slot is confirmed for the webinar. You'll receive a link on your registered number."
          }}
        />

        {slotDate && slotTime && (
          <CalendarTimeContainer>
            <CalendarTimeRow>
              <IconWrapper>
                <MiniCalendar width={16} height={16} fill="#0F172A" />
              </IconWrapper>
              <DateText>{formatDate(slotDate, true)}</DateText>
            </CalendarTimeRow>
            <DividerLine />
            <CalendarTimeRow>
              <IconWrapper>
                <MiniClock width={16} height={16} fill="#0F172A" />
              </IconWrapper>
              <DateText>{formatTime(slotTime)}</DateText>
            </CalendarTimeRow>
          </CalendarTimeContainer>
        )}

        {shouldShowEbookImage && (
          <EBookImage src={EXCLUSIVE_EBOOK_IMAGE_URL} alt="Exclusive eBook" />
        )}
      </SuccessCardContainer>
    </MainContainer>
  );
};
